import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import TextEditor from '../../Simple/TextEditor'

const styles = theme => ({
    root: {
        width: '100%',
        //maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #e0e0e0',
        marginBottom: theme.spacing(2)
    },
    chip: {
        marginLeft: theme.spacing(1),
        //marginBottom: theme.spacing.unit * 1,
        minWidth: 60,
        whiteSpace: 'pre-wrap'
    },
    singleChip: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    confirmedChip: {
        background: '#43a047',
        color: 'white'
    },
    question: {
        fontWeight: 400,
        paddingLeft: 0
    },
    section1: {
        margin: `${theme.spacing(3)}px ${theme.spacing(2)}px`
    },
    section2: {
        margin: theme.spacing(2)
    },
    section3: {
        margin: `${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`
    },
    titleSection: {
        padding: theme.spacing(2),
        borderLeft: theme.spacing(1) + 'px solid ' + theme.palette.primary[500],
        borderBottom: '1px solid #e0e0e0'
    },
    mainTitleSection: {
        padding: theme.spacing(2),
        borderLeft: theme.spacing(2) + 'px solid ' + theme.palette.primary[700],
        borderBottom: '1px solid #e0e0e0',
        background: theme.palette.primary[500]
    },
    statusSection: {
        margin: `${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(1)}px`
    },
    title: {
        fontWeight: 500,
        fontSize: '1.2rem'
    },
    titleInfo: {
        fontWeight: 400,
        fontSize: '1.1rem',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.up(600)]: {
            textAlign: 'right',
            paddingRight: theme.spacing(1) + 'px!important'
        }
    },
    chipWrapper: {
        marginBottom: theme.spacing(1)
    },
    tableCell: {
        padding: `${theme.spacing(1)}px ${theme.spacing(0)}px ${theme.spacing(1)}px ${theme.spacing(1)}px`
    },
    thRowCell: {
        height: 45
    },
    lastRowCell: {
        borderBottom: 'none'
    },
    lastColumnCell: {
        paddingRight: theme.spacing(1) + 'px!important'
    },
    gaugeTitle: {
        textAlign: 'center',
        marginTop: theme.spacing(1)
    },
    statusBlue: {
        background: '#f7f7f7',
        border: '1px solid #e0e0e0',
        marginBottom: -1
    },
    statusText: {
        //color: 'white',
        fontWeight: 500,
        fontSize: '0.9rem'
    },
    tableSection: {
        marginBottom: theme.spacing(1)
    },
    formControl: {
        maxWidth: 75
    },
    leftIcon: {
        marginRight: 10,
        marginLeft: -3
    }
})

class Contract extends PureComponent {
    render() {
        const { classes, offer } = this.props

        return (
            <TextEditor
                value={
                    '<h3 style="margin-bottom:16px">VELKAKIRJA JA TAKAUSSITOUMUS</h3>' +
                    '<table style="width:100%">' +
                    '<tr><td style="vertical-align: top;"><b>Velkoja</b></td><td><p>GF Money Oy</p></td></tr>' +
                    '<tr><td style="vertical-align: top;"><b>Velallinen</b></td><td><p>Nikitec Oy</p></td></tr>' +
                    '<tr><td style="vertical-align: top;"><b>Velan määrä</b></td><td><p>100 000€</p></td></tr>' +
                    '<tr><td style="vertical-align: top;padding-right:16px"><b>Takaisinmaksuaika</b></td><td><p>3 vuotta</p></td></tr>' +
                    '<tr><td style="vertical-align: top;"><b>Muut ehdot</b></td><td><p>Velan vuotuinen korko on viisi (5) prosenttia. Korko maksetaan velan maksun yhteydessä.</p><p>' +
                    '\tVelka erääntyy kerralla kokonaisuudessaan maksettavaksi 1.7.2023.</p><p>' +
                    'Velallisella on oikeus maksaa velka takaisin halutessaan ennen sovittua eräpäivää.</p><p>' +
                    'Viivästyskorko määräytyy korkolain mukaisesti.</p><p>' +
                    'Velallinen tunnustaa allekirjoituksellaan vastaanottaneensa koko velkasumman.</p></td></tr>' +
                    '<tr><td><b>Päiväys</b></td><td>Turussa 1.1.2020</td></tr>' +
                    '</table>'
                }
                onChange={this.handleContractChange}
            />
        )
    }
}

export default withStyles(styles)(Contract)
